import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function RouteBodyClass({ isAuthed = false }) {
  const { pathname } = useLocation();

  useEffect(() => {
    // Remove old route-* and auth-* classes
    document.body.classList.forEach((c) => {
      if (c.startsWith("route-") || c.startsWith("auth-")) {
        document.body.classList.remove(c);
      }
    });

    // Route class
    const safe =
      pathname === "/"
        ? "root"
        : pathname.replace(/\//g, "-").replace(/^-/, "");
    document.body.classList.add(`route-${safe}`);

    // Auth class
    document.body.classList.add(isAuthed ? "auth-logged-in" : "auth-logged-out");
  }, [pathname, isAuthed]);

  return null;
}